var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__clip0_887_8810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.333 25.833a19 19 0 0 1-5.95-.95 1.67 1.67 0 0 0-1.691.409l-3.667 3.675a25.14 25.14 0 0 1-10.983-10.975l3.666-3.675a1.67 1.67 0 0 0 .409-1.692 19 19 0 0 1-.95-5.958A1.66 1.66 0 0 0 12.5 5H6.667A1.66 1.66 0 0 0 5 6.667C5 22.317 17.683 35 33.333 35c.925 0 1.667-.742 1.667-1.667V27.5c0-.925-.742-1.667-1.667-1.667"
  }))));
};
export default SvgPhone;